import * as z from "zod/v4";

export const getUnifiedBillingEnabled = {
  name: "getUnifiedBillingEnabled" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ enabled: z.boolean() }),
};
